import { createRequest, getProxyHeadersPlugin } from '@direct-frontend/modules-request';
import { apiRequestCommon } from '../../apiRequestCommon';

const request = createRequest({
    ...apiRequestCommon,

    headers: {
        accept: 'application/json',
        'content-type': 'application/json',
    },
    jsonContentTypeHeaders: ['application/json'],
    plugins: [
        getProxyHeadersPlugin([
            'x-original-host',
            'cookie',
            'user-agent',
            'accept-language',
            'x-forwarded-for',
            'x-forwarded-for-y',
            'x-real-ip',
            'x-trace-id',
            'traceparent',
            'testname',
            'testRunId',
        ]),
    ],
});

export async function getCSRFTokenRequest() {
    return request<{ token: string }>({
        url: '/csrf-token',
        method: 'GET',
    });
}
